<template>
  <div class="TentangPage">
    <v-app>
      <v-main>
        <v-container>
          <v-col>
            <div class="text-h7 bg" style="color: #939496">Deskripsi</div>
            <h1 style="color: #134280;">Drone ISAI</h1>
          </v-col>
          <v-col align="justify">
            <div>
              <v-row>
                <v-col>
                  <h4>Drone ISAI merupakan sebuah aplikasi berbasis web untuk
                    memprediksi nilai karbon dan memantau dinamika karbon secara kuantitatif pada suatu lahan. Drone ISAI
                    memanfaatkan teknologi pesawat tanpa awak atau sering disebut sebagai drone untuk pengambilan citra
                    suatu lahan. Selain itu, sistem juga dirancang untuk melakukan pengambilan data karbon secara otomatis melalui drone.<br />
                    Sistem diharapkan mampu mempermudahkan petani,
                    pelaku bisnis dan pembuat kebijakan pada sektor pertanian
                    untuk melakukan monitoring dan memahami dinamika karbon serta
                    perubahan kualitas lingkungan yang terjadi pada suatu lahan secara aktual dan presisi.
                  </h4>
                </v-col>
                <v-col>
                  <v-img max-height="350" max-width="350" src="droneISAI-white.png"></v-img>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col>
            <div class="text-h7 bg" style="color: #939496;">Support</div>
            <h1 style="color: #134280;">Para Pihak Pendukung Drone ISAI</h1>
          </v-col>
          <v-row align="center">
            <v-col>
              <v-img max-height="200" max-width="120" src="ukdw.png"></v-img>
            </v-col>
            <v-col>
              <v-img max-height="200" max-width="200" src="fti-ukdw.png"></v-img>
            </v-col>
            <v-col>
              <v-img max-height="250" max-width="250" src="kedaireka.png"></v-img>
            </v-col>
            <v-col>
              <v-img max-height="250" max-width="250" src="3.png"></v-img>
            </v-col>
          </v-row>
          <v-col align="justify">
            <div>
              <v-row>
                <v-col>
                  <h3>Pembangunan sistem ISAI dilaksanakan dibawah naungan PT Aerotek Global Inovasi (Beehive Drones)<br/>
                    dan Fakultas Teknologi Inforamsi (FTI) Universitas Kristen Duta Wacana 
                    melalui skema pendanaan Kedaireka - Kampus Merdeka.
                  </h3>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
     
    }
  }
}
</script>

<style>
.style {
  width: 100%;
  height: 100%;
}
</style>